import gql from 'graphql-tag';

const CAMPAIGN_ORDER_TRANSACTIONS_BY_DATE = gql`
  query campaignOrderTransactionsByDate($id: ID!) {
    transactionReportByDates(
      where: { campaignOrderTransactionReport: { analytics: { campaignOrder: { id: $id } } } }
    ) {
      date
      transactions
      revenue
      spend
      customers
      impressions
      uniqueIdentifiers
    }
  }
`;

export default CAMPAIGN_ORDER_TRANSACTIONS_BY_DATE;
